<script>
import Radio from '@wielink-application/shared/vue/components/form/horizontal/radio.vue'

export default Radio;
</script>